import styled from "styled-components";

export const VideoTitle = styled.div`
  font-family: futura-pt, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 35px;
  margin: auto;
  margin-top: 40px;
  margin-bottom: 27px;

  color: black;
`;
